// ISO 3166-1 alpha-2 ülke listesi. Türkçe ada göre sıralıdır.
// DHL servisleri ülke kodunu (code) beklediği için formlarda bu alan saklanır.
// dialCode: telefon alan kodu (kaynak: world-countries idd verisi).
const CountryList = [
  { code: 'UM', name: "U.S. Outlying Islands", nameTr: "ABD Küçük Harici Adaları", dialCode: '+268' },
  { code: 'VI', name: "U.S. Virgin Islands", nameTr: "ABD Virjin Adaları", dialCode: '+1340' },
  { code: 'AF', name: "Afghanistan", nameTr: "Afganistan", dialCode: '+93' },
  { code: 'AX', name: "Åland Islands", nameTr: "Åland Adaları", dialCode: '+35818' },
  { code: 'DE', name: "Germany", nameTr: "Almanya", dialCode: '+49' },
  { code: 'US', name: "United States", nameTr: "Amerika Birleşik Devletleri", dialCode: '+1' },
  { code: 'AS', name: "American Samoa", nameTr: "Amerikan Samoası", dialCode: '+1684' },
  { code: 'AD', name: "Andorra", nameTr: "Andorra", dialCode: '+376' },
  { code: 'AO', name: "Angola", nameTr: "Angola", dialCode: '+244' },
  { code: 'AI', name: "Anguilla", nameTr: "Anguilla", dialCode: '+1264' },
  { code: 'AQ', name: "Antarctica", nameTr: "Antarktika", dialCode: '' },
  { code: 'AG', name: "Antigua & Barbuda", nameTr: "Antigua ve Barbuda", dialCode: '+1268' },
  { code: 'AR', name: "Argentina", nameTr: "Arjantin", dialCode: '+54' },
  { code: 'AL', name: "Albania", nameTr: "Arnavutluk", dialCode: '+355' },
  { code: 'AW', name: "Aruba", nameTr: "Aruba", dialCode: '+297' },
  { code: 'AU', name: "Australia", nameTr: "Avustralya", dialCode: '+61' },
  { code: 'AT', name: "Austria", nameTr: "Avusturya", dialCode: '+43' },
  { code: 'AZ', name: "Azerbaijan", nameTr: "Azerbaycan", dialCode: '+994' },
  { code: 'BS', name: "Bahamas", nameTr: "Bahamalar", dialCode: '+1242' },
  { code: 'BH', name: "Bahrain", nameTr: "Bahreyn", dialCode: '+973' },
  { code: 'BD', name: "Bangladesh", nameTr: "Bangladeş", dialCode: '+880' },
  { code: 'BB', name: "Barbados", nameTr: "Barbados", dialCode: '+1246' },
  { code: 'EH', name: "Western Sahara", nameTr: "Batı Sahra", dialCode: '+2' },
  { code: 'BY', name: "Belarus", nameTr: "Belarus", dialCode: '+375' },
  { code: 'BE', name: "Belgium", nameTr: "Belçika", dialCode: '+32' },
  { code: 'BZ', name: "Belize", nameTr: "Belize", dialCode: '+501' },
  { code: 'BJ', name: "Benin", nameTr: "Benin", dialCode: '+229' },
  { code: 'BM', name: "Bermuda", nameTr: "Bermuda", dialCode: '+1441' },
  { code: 'AE', name: "United Arab Emirates", nameTr: "Birleşik Arap Emirlikleri", dialCode: '+971' },
  { code: 'GB', name: "United Kingdom", nameTr: "Birleşik Krallık", dialCode: '+44' },
  { code: 'BO', name: "Bolivia", nameTr: "Bolivya", dialCode: '+591' },
  { code: 'BA', name: "Bosnia & Herzegovina", nameTr: "Bosna-Hersek", dialCode: '+387' },
  { code: 'BW', name: "Botswana", nameTr: "Botsvana", dialCode: '+267' },
  { code: 'BV', name: "Bouvet Island", nameTr: "Bouvet Adası", dialCode: '+47' },
  { code: 'BR', name: "Brazil", nameTr: "Brezilya", dialCode: '+55' },
  { code: 'IO', name: "British Indian Ocean Territory", nameTr: "Britanya Hint Okyanusu Toprakları", dialCode: '+246' },
  { code: 'VG', name: "British Virgin Islands", nameTr: "Britanya Virjin Adaları", dialCode: '+1284' },
  { code: 'BN', name: "Brunei", nameTr: "Brunei", dialCode: '+673' },
  { code: 'BG', name: "Bulgaria", nameTr: "Bulgaristan", dialCode: '+359' },
  { code: 'BF', name: "Burkina Faso", nameTr: "Burkina Faso", dialCode: '+226' },
  { code: 'BI', name: "Burundi", nameTr: "Burundi", dialCode: '+257' },
  { code: 'BT', name: "Bhutan", nameTr: "Butan", dialCode: '+975' },
  { code: 'CV', name: "Cape Verde", nameTr: "Cabo Verde", dialCode: '+238' },
  { code: 'KY', name: "Cayman Islands", nameTr: "Cayman Adaları", dialCode: '+1345' },
  { code: 'GI', name: "Gibraltar", nameTr: "Cebelitarık", dialCode: '+350' },
  { code: 'DZ', name: "Algeria", nameTr: "Cezayir", dialCode: '+213' },
  { code: 'CX', name: "Christmas Island", nameTr: "Christmas Adası", dialCode: '+61' },
  { code: 'DJ', name: "Djibouti", nameTr: "Cibuti", dialCode: '+253' },
  { code: 'CC', name: "Cocos (Keeling) Islands", nameTr: "Cocos (Keeling) Adaları", dialCode: '+61' },
  { code: 'CK', name: "Cook Islands", nameTr: "Cook Adaları", dialCode: '+682' },
  { code: 'CI', name: "Côte d’Ivoire", nameTr: "Côte d’Ivoire", dialCode: '+225' },
  { code: 'CW', name: "Curaçao", nameTr: "Curaçao", dialCode: '+599' },
  { code: 'TD', name: "Chad", nameTr: "Çad", dialCode: '+235' },
  { code: 'CZ', name: "Czechia", nameTr: "Çekya", dialCode: '+420' },
  { code: 'CN', name: "China", nameTr: "Çin", dialCode: '+86' },
  { code: 'HK', name: "Hong Kong SAR China", nameTr: "Çin Hong Kong ÖİB", dialCode: '+852' },
  { code: 'MO', name: "Macao SAR China", nameTr: "Çin Makao ÖİB", dialCode: '+853' },
  { code: 'DK', name: "Denmark", nameTr: "Danimarka", dialCode: '+45' },
  { code: 'DO', name: "Dominican Republic", nameTr: "Dominik Cumhuriyeti", dialCode: '+1' },
  { code: 'DM', name: "Dominica", nameTr: "Dominika", dialCode: '+1767' },
  { code: 'EC', name: "Ecuador", nameTr: "Ekvador", dialCode: '+593' },
  { code: 'GQ', name: "Equatorial Guinea", nameTr: "Ekvator Ginesi", dialCode: '+240' },
  { code: 'SV', name: "El Salvador", nameTr: "El Salvador", dialCode: '+503' },
  { code: 'ID', name: "Indonesia", nameTr: "Endonezya", dialCode: '+62' },
  { code: 'ER', name: "Eritrea", nameTr: "Eritre", dialCode: '+291' },
  { code: 'AM', name: "Armenia", nameTr: "Ermenistan", dialCode: '+374' },
  { code: 'EE', name: "Estonia", nameTr: "Estonya", dialCode: '+372' },
  { code: 'SZ', name: "Eswatini", nameTr: "Esvatini", dialCode: '+268' },
  { code: 'ET', name: "Ethiopia", nameTr: "Etiyopya", dialCode: '+251' },
  { code: 'FK', name: "Falkland Islands", nameTr: "Falkland Adaları", dialCode: '+500' },
  { code: 'FO', name: "Faroe Islands", nameTr: "Faroe Adaları", dialCode: '+298' },
  { code: 'MA', name: "Morocco", nameTr: "Fas", dialCode: '+212' },
  { code: 'FJ', name: "Fiji", nameTr: "Fiji", dialCode: '+679' },
  { code: 'PH', name: "Philippines", nameTr: "Filipinler", dialCode: '+63' },
  { code: 'PS', name: "Palestinian Territories", nameTr: "Filistin Bölgeleri", dialCode: '+970' },
  { code: 'FI', name: "Finland", nameTr: "Finlandiya", dialCode: '+358' },
  { code: 'FR', name: "France", nameTr: "Fransa", dialCode: '+33' },
  { code: 'GF', name: "French Guiana", nameTr: "Fransız Guyanası", dialCode: '+594' },
  { code: 'TF', name: "French Southern Territories", nameTr: "Fransız Güney Toprakları", dialCode: '+262' },
  { code: 'PF', name: "French Polynesia", nameTr: "Fransız Polinezyası", dialCode: '+689' },
  { code: 'GA', name: "Gabon", nameTr: "Gabon", dialCode: '+241' },
  { code: 'GM', name: "Gambia", nameTr: "Gambiya", dialCode: '+220' },
  { code: 'GH', name: "Ghana", nameTr: "Gana", dialCode: '+233' },
  { code: 'GN', name: "Guinea", nameTr: "Gine", dialCode: '+224' },
  { code: 'GW', name: "Guinea-Bissau", nameTr: "Gine-Bissau", dialCode: '+245' },
  { code: 'GD', name: "Grenada", nameTr: "Grenada", dialCode: '+1473' },
  { code: 'GL', name: "Greenland", nameTr: "Grönland", dialCode: '+299' },
  { code: 'GP', name: "Guadeloupe", nameTr: "Guadeloupe", dialCode: '+590' },
  { code: 'GU', name: "Guam", nameTr: "Guam", dialCode: '+1671' },
  { code: 'GT', name: "Guatemala", nameTr: "Guatemala", dialCode: '+502' },
  { code: 'GG', name: "Guernsey", nameTr: "Guernsey", dialCode: '+44' },
  { code: 'GY', name: "Guyana", nameTr: "Guyana", dialCode: '+592' },
  { code: 'ZA', name: "South Africa", nameTr: "Güney Afrika", dialCode: '+27' },
  { code: 'GS', name: "South Georgia & South Sandwich Islands", nameTr: "Güney Georgia ve Güney Sandwich Adaları", dialCode: '+500' },
  { code: 'KR', name: "South Korea", nameTr: "Güney Kore", dialCode: '+82' },
  { code: 'SS', name: "South Sudan", nameTr: "Güney Sudan", dialCode: '+211' },
  { code: 'GE', name: "Georgia", nameTr: "Gürcistan", dialCode: '+995' },
  { code: 'HT', name: "Haiti", nameTr: "Haiti", dialCode: '+509' },
  { code: 'HM', name: "Heard & McDonald Islands", nameTr: "Heard Adası ve McDonald Adaları", dialCode: '' },
  { code: 'HR', name: "Croatia", nameTr: "Hırvatistan", dialCode: '+385' },
  { code: 'IN', name: "India", nameTr: "Hindistan", dialCode: '+91' },
  { code: 'NL', name: "Netherlands", nameTr: "Hollanda", dialCode: '+31' },
  { code: 'HN', name: "Honduras", nameTr: "Honduras", dialCode: '+504' },
  { code: 'IQ', name: "Iraq", nameTr: "Irak", dialCode: '+964' },
  { code: 'IR', name: "Iran", nameTr: "İran", dialCode: '+98' },
  { code: 'IE', name: "Ireland", nameTr: "İrlanda", dialCode: '+353' },
  { code: 'ES', name: "Spain", nameTr: "İspanya", dialCode: '+34' },
  { code: 'IL', name: "Israel", nameTr: "İsrail", dialCode: '+972' },
  { code: 'SE', name: "Sweden", nameTr: "İsveç", dialCode: '+46' },
  { code: 'CH', name: "Switzerland", nameTr: "İsviçre", dialCode: '+41' },
  { code: 'IT', name: "Italy", nameTr: "İtalya", dialCode: '+39' },
  { code: 'IS', name: "Iceland", nameTr: "İzlanda", dialCode: '+354' },
  { code: 'JM', name: "Jamaica", nameTr: "Jamaika", dialCode: '+1876' },
  { code: 'JP', name: "Japan", nameTr: "Japonya", dialCode: '+81' },
  { code: 'JE', name: "Jersey", nameTr: "Jersey", dialCode: '+44' },
  { code: 'KH', name: "Cambodia", nameTr: "Kamboçya", dialCode: '+855' },
  { code: 'CM', name: "Cameroon", nameTr: "Kamerun", dialCode: '+237' },
  { code: 'CA', name: "Canada", nameTr: "Kanada", dialCode: '+1' },
  { code: 'ME', name: "Montenegro", nameTr: "Karadağ", dialCode: '+382' },
  { code: 'BQ', name: "Caribbean Netherlands", nameTr: "Karayip Hollandası", dialCode: '+599' },
  { code: 'QA', name: "Qatar", nameTr: "Katar", dialCode: '+974' },
  { code: 'KZ', name: "Kazakhstan", nameTr: "Kazakistan", dialCode: '+7' },
  { code: 'KE', name: "Kenya", nameTr: "Kenya", dialCode: '+254' },
  { code: 'CY', name: "Cyprus", nameTr: "Kıbrıs", dialCode: '+357' },
  { code: 'KG', name: "Kyrgyzstan", nameTr: "Kırgızistan", dialCode: '+996' },
  { code: 'KI', name: "Kiribati", nameTr: "Kiribati", dialCode: '+686' },
  { code: 'CO', name: "Colombia", nameTr: "Kolombiya", dialCode: '+57' },
  { code: 'KM', name: "Comoros", nameTr: "Komorlar", dialCode: '+269' },
  { code: 'CG', name: "Congo - Brazzaville", nameTr: "Kongo - Brazavil", dialCode: '+242' },
  { code: 'CD', name: "Congo - Kinshasa", nameTr: "Kongo - Kinşasa", dialCode: '+243' },
  { code: 'CR', name: "Costa Rica", nameTr: "Kosta Rika", dialCode: '+506' },
  { code: 'KW', name: "Kuwait", nameTr: "Kuveyt", dialCode: '+965' },
  { code: 'KP', name: "North Korea", nameTr: "Kuzey Kore", dialCode: '+850' },
  { code: 'MK', name: "North Macedonia", nameTr: "Kuzey Makedonya", dialCode: '+389' },
  { code: 'MP', name: "Northern Mariana Islands", nameTr: "Kuzey Mariana Adaları", dialCode: '+1670' },
  { code: 'CU', name: "Cuba", nameTr: "Küba", dialCode: '+53' },
  { code: 'LA', name: "Laos", nameTr: "Laos", dialCode: '+856' },
  { code: 'LS', name: "Lesotho", nameTr: "Lesotho", dialCode: '+266' },
  { code: 'LV', name: "Latvia", nameTr: "Letonya", dialCode: '+371' },
  { code: 'LR', name: "Liberia", nameTr: "Liberya", dialCode: '+231' },
  { code: 'LY', name: "Libya", nameTr: "Libya", dialCode: '+218' },
  { code: 'LI', name: "Liechtenstein", nameTr: "Liechtenstein", dialCode: '+423' },
  { code: 'LT', name: "Lithuania", nameTr: "Litvanya", dialCode: '+370' },
  { code: 'LB', name: "Lebanon", nameTr: "Lübnan", dialCode: '+961' },
  { code: 'LU', name: "Luxembourg", nameTr: "Lüksemburg", dialCode: '+352' },
  { code: 'HU', name: "Hungary", nameTr: "Macaristan", dialCode: '+36' },
  { code: 'MG', name: "Madagascar", nameTr: "Madagaskar", dialCode: '+261' },
  { code: 'MW', name: "Malawi", nameTr: "Malavi", dialCode: '+265' },
  { code: 'MV', name: "Maldives", nameTr: "Maldivler", dialCode: '+960' },
  { code: 'MY', name: "Malaysia", nameTr: "Malezya", dialCode: '+60' },
  { code: 'ML', name: "Mali", nameTr: "Mali", dialCode: '+223' },
  { code: 'MT', name: "Malta", nameTr: "Malta", dialCode: '+356' },
  { code: 'IM', name: "Isle of Man", nameTr: "Man Adası", dialCode: '+44' },
  { code: 'MH', name: "Marshall Islands", nameTr: "Marshall Adaları", dialCode: '+692' },
  { code: 'MQ', name: "Martinique", nameTr: "Martinik", dialCode: '+596' },
  { code: 'MU', name: "Mauritius", nameTr: "Mauritius", dialCode: '+230' },
  { code: 'YT', name: "Mayotte", nameTr: "Mayotte", dialCode: '+262' },
  { code: 'MX', name: "Mexico", nameTr: "Meksika", dialCode: '+52' },
  { code: 'EG', name: "Egypt", nameTr: "Mısır", dialCode: '+20' },
  { code: 'FM', name: "Micronesia", nameTr: "Mikronezya", dialCode: '+691' },
  { code: 'MN', name: "Mongolia", nameTr: "Moğolistan", dialCode: '+976' },
  { code: 'MD', name: "Moldova", nameTr: "Moldova", dialCode: '+373' },
  { code: 'MC', name: "Monaco", nameTr: "Monako", dialCode: '+377' },
  { code: 'MS', name: "Montserrat", nameTr: "Montserrat", dialCode: '+1664' },
  { code: 'MR', name: "Mauritania", nameTr: "Moritanya", dialCode: '+222' },
  { code: 'MZ', name: "Mozambique", nameTr: "Mozambik", dialCode: '+258' },
  { code: 'MM', name: "Myanmar (Burma)", nameTr: "Myanmar (Burma)", dialCode: '+95' },
  { code: 'NA', name: "Namibia", nameTr: "Namibya", dialCode: '+264' },
  { code: 'NR', name: "Nauru", nameTr: "Nauru", dialCode: '+674' },
  { code: 'NP', name: "Nepal", nameTr: "Nepal", dialCode: '+977' },
  { code: 'NE', name: "Niger", nameTr: "Nijer", dialCode: '+227' },
  { code: 'NG', name: "Nigeria", nameTr: "Nijerya", dialCode: '+234' },
  { code: 'NI', name: "Nicaragua", nameTr: "Nikaragua", dialCode: '+505' },
  { code: 'NU', name: "Niue", nameTr: "Niue", dialCode: '+683' },
  { code: 'NF', name: "Norfolk Island", nameTr: "Norfolk Adası", dialCode: '+672' },
  { code: 'NO', name: "Norway", nameTr: "Norveç", dialCode: '+47' },
  { code: 'CF', name: "Central African Republic", nameTr: "Orta Afrika Cumhuriyeti", dialCode: '+236' },
  { code: 'UZ', name: "Uzbekistan", nameTr: "Özbekistan", dialCode: '+998' },
  { code: 'PK', name: "Pakistan", nameTr: "Pakistan", dialCode: '+92' },
  { code: 'PW', name: "Palau", nameTr: "Palau", dialCode: '+680' },
  { code: 'PA', name: "Panama", nameTr: "Panama", dialCode: '+507' },
  { code: 'PG', name: "Papua New Guinea", nameTr: "Papua Yeni Gine", dialCode: '+675' },
  { code: 'PY', name: "Paraguay", nameTr: "Paraguay", dialCode: '+595' },
  { code: 'PE', name: "Peru", nameTr: "Peru", dialCode: '+51' },
  { code: 'PN', name: "Pitcairn Islands", nameTr: "Pitcairn Adaları", dialCode: '+64' },
  { code: 'PL', name: "Poland", nameTr: "Polonya", dialCode: '+48' },
  { code: 'PT', name: "Portugal", nameTr: "Portekiz", dialCode: '+351' },
  { code: 'PR', name: "Puerto Rico", nameTr: "Porto Riko", dialCode: '+1' },
  { code: 'RE', name: "Réunion", nameTr: "Reunion", dialCode: '+262' },
  { code: 'RO', name: "Romania", nameTr: "Romanya", dialCode: '+40' },
  { code: 'RW', name: "Rwanda", nameTr: "Ruanda", dialCode: '+250' },
  { code: 'RU', name: "Russia", nameTr: "Rusya", dialCode: '+7' },
  { code: 'BL', name: "St. Barthélemy", nameTr: "Saint Barthelemy", dialCode: '+590' },
  { code: 'SH', name: "St. Helena", nameTr: "Saint Helena", dialCode: '+2' },
  { code: 'KN', name: "St. Kitts & Nevis", nameTr: "Saint Kitts ve Nevis", dialCode: '+1869' },
  { code: 'LC', name: "St. Lucia", nameTr: "Saint Lucia", dialCode: '+1758' },
  { code: 'MF', name: "St. Martin", nameTr: "Saint Martin", dialCode: '+590' },
  { code: 'PM', name: "St. Pierre & Miquelon", nameTr: "Saint Pierre ve Miquelon", dialCode: '+508' },
  { code: 'VC', name: "St. Vincent & Grenadines", nameTr: "Saint Vincent ve Grenadinler", dialCode: '+1784' },
  { code: 'WS', name: "Samoa", nameTr: "Samoa", dialCode: '+685' },
  { code: 'SM', name: "San Marino", nameTr: "San Marino", dialCode: '+378' },
  { code: 'ST', name: "São Tomé & Príncipe", nameTr: "Sao Tome ve Principe", dialCode: '+239' },
  { code: 'SN', name: "Senegal", nameTr: "Senegal", dialCode: '+221' },
  { code: 'SC', name: "Seychelles", nameTr: "Seyşeller", dialCode: '+248' },
  { code: 'RS', name: "Serbia", nameTr: "Sırbistan", dialCode: '+381' },
  { code: 'SL', name: "Sierra Leone", nameTr: "Sierra Leone", dialCode: '+232' },
  { code: 'SG', name: "Singapore", nameTr: "Singapur", dialCode: '+65' },
  { code: 'SX', name: "Sint Maarten", nameTr: "Sint Maarten", dialCode: '+1721' },
  { code: 'SK', name: "Slovakia", nameTr: "Slovakya", dialCode: '+421' },
  { code: 'SI', name: "Slovenia", nameTr: "Slovenya", dialCode: '+386' },
  { code: 'SB', name: "Solomon Islands", nameTr: "Solomon Adaları", dialCode: '+677' },
  { code: 'SO', name: "Somalia", nameTr: "Somali", dialCode: '+252' },
  { code: 'LK', name: "Sri Lanka", nameTr: "Sri Lanka", dialCode: '+94' },
  { code: 'SD', name: "Sudan", nameTr: "Sudan", dialCode: '+249' },
  { code: 'SR', name: "Suriname", nameTr: "Surinam", dialCode: '+597' },
  { code: 'SY', name: "Syria", nameTr: "Suriye", dialCode: '+963' },
  { code: 'SA', name: "Saudi Arabia", nameTr: "Suudi Arabistan", dialCode: '+966' },
  { code: 'SJ', name: "Svalbard & Jan Mayen", nameTr: "Svalbard ve Jan Mayen", dialCode: '+4779' },
  { code: 'CL', name: "Chile", nameTr: "Şili", dialCode: '+56' },
  { code: 'TJ', name: "Tajikistan", nameTr: "Tacikistan", dialCode: '+992' },
  { code: 'TZ', name: "Tanzania", nameTr: "Tanzanya", dialCode: '+255' },
  { code: 'TH', name: "Thailand", nameTr: "Tayland", dialCode: '+66' },
  { code: 'TW', name: "Taiwan", nameTr: "Tayvan", dialCode: '+886' },
  { code: 'TL', name: "Timor-Leste", nameTr: "Timor-Leste", dialCode: '+670' },
  { code: 'TG', name: "Togo", nameTr: "Togo", dialCode: '+228' },
  { code: 'TK', name: "Tokelau", nameTr: "Tokelau", dialCode: '+690' },
  { code: 'TO', name: "Tonga", nameTr: "Tonga", dialCode: '+676' },
  { code: 'TT', name: "Trinidad & Tobago", nameTr: "Trinidad ve Tobago", dialCode: '+1868' },
  { code: 'TN', name: "Tunisia", nameTr: "Tunus", dialCode: '+216' },
  { code: 'TC', name: "Turks & Caicos Islands", nameTr: "Turks ve Caicos Adaları", dialCode: '+1649' },
  { code: 'TV', name: "Tuvalu", nameTr: "Tuvalu", dialCode: '+688' },
  { code: 'TR', name: "Türkiye", nameTr: "Türkiye", dialCode: '+90' },
  { code: 'TM', name: "Turkmenistan", nameTr: "Türkmenistan", dialCode: '+993' },
  { code: 'UG', name: "Uganda", nameTr: "Uganda", dialCode: '+256' },
  { code: 'UA', name: "Ukraine", nameTr: "Ukrayna", dialCode: '+380' },
  { code: 'OM', name: "Oman", nameTr: "Umman", dialCode: '+968' },
  { code: 'UY', name: "Uruguay", nameTr: "Uruguay", dialCode: '+598' },
  { code: 'JO', name: "Jordan", nameTr: "Ürdün", dialCode: '+962' },
  { code: 'VU', name: "Vanuatu", nameTr: "Vanuatu", dialCode: '+678' },
  { code: 'VA', name: "Vatican City", nameTr: "Vatikan", dialCode: '+3' },
  { code: 'VE', name: "Venezuela", nameTr: "Venezuela", dialCode: '+58' },
  { code: 'VN', name: "Vietnam", nameTr: "Vietnam", dialCode: '+84' },
  { code: 'WF', name: "Wallis & Futuna", nameTr: "Wallis ve Futuna", dialCode: '+681' },
  { code: 'YE', name: "Yemen", nameTr: "Yemen", dialCode: '+967' },
  { code: 'NC', name: "New Caledonia", nameTr: "Yeni Kaledonya", dialCode: '+687' },
  { code: 'NZ', name: "New Zealand", nameTr: "Yeni Zelanda", dialCode: '+64' },
  { code: 'GR', name: "Greece", nameTr: "Yunanistan", dialCode: '+30' },
  { code: 'ZM', name: "Zambia", nameTr: "Zambiya", dialCode: '+260' },
  { code: 'ZW', name: "Zimbabwe", nameTr: "Zimbabve", dialCode: '+263' },
];

export function getDialCode(code) {
  const country = CountryList.find((item) => item.code === code);
  return country?.dialCode || '';
}

export default CountryList;
